import * as React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { reduxForm } from 'redux-form';
import { Dialog } from 'material-ui';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Uploader, UploaderField } from '@components/form';
import { TripsImportModal } from '@modules/trips/TripsImportModal';

import * as T from '@modules/trips/_tripsTypes';
import { EnhancedExportButton } from '@components/exportButton/ExportButton';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

const enhance = compose<any, any>(
  reduxForm({
    form: 'trips-import'
  }),
  withState<{}, boolean, string, string>('showModal', 'handleShowModal', false),
  withState<{}, Array<T.ImportModal>, string, string>('savedTrips', 'handleSavedTrips', []),
  withState<{}, Array<T.ImportModal>, string, string>('notSavedTrips', 'handleNotSavedTrips', []),
  withHandlers({
    onComplete: ({ handleShowModal, handleSavedTrips, handleNotSavedTrips }) => complete => {
      const unfilteredTrips: Array<T.TripImport> = complete.response;
      const savedTrips = unfilteredTrips.filter(o => o.found);
      const notSavedTrips = unfilteredTrips.filter(trip => !trip.found);

      handleSavedTrips(savedTrips);
      handleNotSavedTrips(notSavedTrips);
      handleShowModal(true);
    },
    handleRequestClose: ({ refresh, handleShowModal }) => () => {
      if (refresh) {
        refresh();
      }
      handleShowModal(false);
    }
  })
);

const View = ({ savedTrips, notSavedTrips, showModal, handleRequestClose, state, ...props }) => {
  const params = {
    sort: state.sort,
    order: state.order,
    page: state.page,
    pageSize: state.pageSize,
    filters: state.filters,
    checkedItems: state.checkedItems
  };
  return (
    <>
      <ColumnManager agenda={Agenda.TRIPS} />
      <EnhancedExportButton location={'tripOverview'} params={params} />
      <div style={{ marginLeft: 5 }}>
        <Button>
          <UploaderField
            {...props}
            component={Uploader}
            url="/metropolis/api/cl/trip/import-ccs-records/"
            name="import"
          >
            <div
              style={{
                color: 'rgba(0, 0, 0, 0.87)',
                transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
                borderRadius: '2px',
                minWidth: '88px',
                fontSize: '14px'
              }}
            >
              <span>IMPORT</span>
            </div>
          </UploaderField>
        </Button>
        <Dialog bodyStyle={{ padding: '0' }} open={showModal} onRequestClose={handleRequestClose}>
          <TripsImportModal savedTrips={savedTrips} notSavedTrips={notSavedTrips} onRequestClose={handleRequestClose} />
        </Dialog>
      </div>
    </>
  );
};

export const ActionBar = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/trips/TripsGridButtons.tsx